import { GetApp } from "../../App"
import { Block, BlockField, BlockRow } from "../../Components/Block"
import { dayToDate } from "../DayView"
import { GetData } from "./Context"
import { PrintDayListViewProps } from "./Params"

export function PrintDayListView({ day }: PrintDayListViewProps) {
  const app = GetApp();
  const _data = GetData();
  const date = dayToDate(day.day);
  const tc = app.getT("PrintView");
  const _t = app.getT("DayEditView");
  const ts = app.getT("StatsView");

  const calculated = day.calculated;

  return (
    <Block className="PrintDayListView">
      <BlockRow className="print-day-list-row">
        <BlockField label={tc("date")} className="block-field-150 label-left">{app.format("date", date.toISOString())}</BlockField>
        <BlockField label={tc("from_loc")} className="block-field-225">{day.startLocation}</BlockField>
        <BlockField label={tc("to_loc")} className="block-field-225">{day.endLocation}</BlockField>
        <BlockField label={ts("time_total")} className="block-field-90 ">{app.format("timeh", calculated?.duration)}</BlockField>
        <BlockField label={ts("distance_total")} className="block-field-120 print-field-text-right">{app.format("distance", calculated?.distance)}</BlockField>
      </BlockRow>
    </Block>
  );
}
